import { useNavigate } from "react-router-dom";

export const FooterPublic = () => {
  const navigate = useNavigate();
  return (
    <footer className="mt-16 bg-gradient-to-t from-black via-gray-950 to-transparent">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="text-lg font-semibold text-white">Bizecho</h4>
            <p className="text-sm text-gray-400 mt-2">
              A WhatsApp-first CRM for Automobile Companies. Automate feedback,
              manage leads, and increase conversions.
            </p>
            <div className="mt-4 flex gap-4 text-gray-400">
              <a href="#">LinkedIn</a>
              <a href="#">Facebook</a>
            </div>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-teal-300">Quick Links</h5>
            <ul className="mt-3 text-sm text-gray-400 space-y-2">
              <li>
                <a href="#products">Products</a>
              </li>
              <li>
                <a href="#dashboard">Reports</a>
              </li>
              <li>
                <a href="#faq">FAQ</a>
              </li>
              <li>
                <button
                  onClick={() => navigate("/privacy-policy")}
                  className="block py-2 pl-3 pr-4 text-gray-400 rounded lg:bg-transparent lg:p-0 dark:text-white"
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-teal-300">Contact</h5>
            <a
              href="tel:9833635399"
              className="text-gray-400 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm py-2.5 mr-2 mb-2focus:outline-none "
            >
              Call Us : +91 9833635399
            </a>
            <br />
            <a
              href="mailto:contact@bizecho.co.in"
              className="text-gray-400 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm  py-2.5 mr-2 mb-2 "
            >
              Email us : contact@bizecho.co.in
            </a>
            <div className="mt-4">
              <button
                onClick={() => navigate("/book-a-demo")}
                className="inline-flex items-center gap-2 px-5 py-2 rounded-md bg-gradient-to-r from-teal-400 to-cyan-400 text-gray-900 font-semibold shadow-lg hover:brightness-110"
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>

        <div className="mt-10 text-xs text-gray-600 text-center">
          © {new Date().getFullYear()} Bizecho — All rights reserved.
        </div>
      </div>
    </footer>
  );
};
